import React from 'react'
import { getFieldValue, getSafe } from '../../shared/utilities'

// Candidate widths the browser can choose from via srcset.
const SRCSET_WIDTHS = [320, 480, 640, 960, 1280]
const ASPECT_RATIO = 0.75 // 4:3 (height / width)

const contentfulUrl = (url, width) => {
  const height = Math.round(width * ASPECT_RATIO)
  return `${url}?w=${width}&h=${height}&fit=fill&fm=webp`
}

const BlockImageRow = ({ fields }) => {
  const images = getFieldValue(fields, 'images')
  const cols = images.length

  const renderedImages = images.map(image => {
    const { id } = image.sys
    const alt = getSafe(() => image.fields.title['en-US']) || ''
    const url = getSafe(() => image.fields.file['en-US'].url)
    if (!url) return null

    const srcSet = SRCSET_WIDTHS.map(w => `${contentfulUrl(url, w)} ${w}w`).join(', ')

    return (
      <img
        key={id}
        alt={alt}
        src={contentfulUrl(url, 640)}
        srcSet={srcSet}
        sizes={`(max-width: 767px) 100vw, ${Math.round(100 / cols)}vw`}
        loading="lazy"
        decoding="async"
      />
    )
  })

  return (
    <span className="block-image-row" style={{ '--cols': cols }}>
      {renderedImages}
    </span>
  )
}

export default BlockImageRow
